const MIN_AGE_DEFAULT = 18;
const MIN_AGE_FR = 16;

export function getMinAgeForLegalCountry(legalCountry?: string | null): number {
  return legalCountry === 'FR' ? MIN_AGE_FR : MIN_AGE_DEFAULT;
}
